import { render, staticRenderFns } from "./TopCarousel.vue?vue&type=template&id=32c1f648&scoped=true&"
import script from "./TopCarousel.vue?vue&type=script&lang=js&"
export * from "./TopCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TopCarousel.vue?vue&type=style&index=0&id=32c1f648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1f648",
  null
  
)

export default component.exports